import React from 'react';
import { Upload as LucideUpload } from 'lucide-react';

interface UploadProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Upload: React.FC<UploadProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideUpload width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Upload;
